import { Injectable } from '@angular/core';
import { CookieService } from '../Services/cookie';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { ConfigService } from './config.service';
import { HttpServiceService } from './http-service.service';

@Injectable({
  providedIn: 'root'
})
export class AdditionalDocService {

  constructor(private http: HttpServiceService, private auth: AuthService, private cookieService: CookieService, private config: ConfigService, private common: CommonService) { }

  public GetDocConfigFLowURL = "AdditionalDoc/GetDocConfigFLow"
  public SaveLimitDocURL = "AdditionalDoc/SaveLimitDocuments"



  GetDocConfigFLow(Flow, token) {
    console.log('GetDocConfigFLowReq', Flow,token );
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetDocConfigFLowURL, {Flow:Flow}, token).subscribe((res: any) => {
        resolve(res)
        console.log('GetDocConfigFLowRes',res);
      }, (Error) => {
        resolve(Error);
        console.log('GetDocConfigFLowError',Error );
      })
    })
  }


  SaveLimitDoc(body, token) {
    console.log('SaveLimitDocReq', body);
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.SaveLimitDocURL,body , token).subscribe((res: any) => {
        resolve(res)
        console.log('SaveLimitDocRes',res);
      }, (Error) => {
        resolve(Error);
        console.log('SaveLimitDocError',Error );
      })
    })
  }
}
